import { Component, EventEmitter, Input, Output, Renderer2, Inject } from '@angular/core';
import { apiService } from 'app/services/api.service';
import { globalData } from "app/services/globalData.service";
import { DatePipe } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-flight-payment',
  templateUrl: './flight-payment.component.html',
  styleUrls: ['./flight-payment.component.scss'],
  providers: [DatePipe]
})
export class FlightPaymentComponent {
  @Output() close = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();

  @Input() searchRequestType: string;
  @Input() oneWaySummary: any; // Adjust the type based on your data structure
  @Input() roundTripSummary: any; // Adjust the type based on your data structure
  @Input() multiCitySummary: any;
  @Input() travellersData: any[];

  isPaymentCompleted: boolean = false;
  isPaymentStart: boolean = false;

  // app-flight-payment.component.ts

@Input() flightPriceByTraveller: any[];
  @Input() flightOfferPriceDetail: any;
  @Input() selectedFlight: any;
  
  displayCurrency = localStorage.getItem('displayCurrency');
  languageCode = localStorage.getItem('languageCode');

  flightOfferDetail: any;
  contactNumber: any;
  contactNumberIsd: any;
  contactEmail: any;
  contactAddress1: any;
  contactAddress2: any;
  contactZipCode: any;
  contactStateName: any;
  contactCityName: any;
  contactCountryName: any;
  bookingResponse: any;

  bookingRequest: any;
  constructor(private _apiService: apiService,
    public global: globalData,
    private datePipe: DatePipe,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document) {
    // this.minDate = new Date();
  }

  onClose() {
    this.close.emit();
  }

  onBackClick() {
    this.goBack.emit();
  }

  handlePaymentButtonClick() {
    this.isPaymentCompleted = true;    
  }

  travelers = [
    {
      name: 'Mr Abdelslam Aly',
      type: 'Adult',
      dob: '30 May 1998',
      nationality: 'India',
      passportNumber: '848856992',
      expiryDate: '02 June 2027',
      issueCountry: 'India',
      total: 1000, // Add the 'total' property with a sample value
      fare: 800,   // Add the 'fare' property with a sample value
      taxes: 200   // Add the 'taxes' property with a sample value
    },
    {
      name: 'Somya Martand',
      type: 'Adult',
      dob: '18 May 1996',
      nationality: 'India',
      passportNumber: '848856992',
      expiryDate: '02 June 2025',
      issueCountry: 'India',
      total: 1200, // Add the 'total' property with a sample value
      fare: 950,   // Add the 'fare' property with a sample value
      taxes: 250   // Add the 'taxes' property with a sample value
    },

  ];

  bookingProcessStart: boolean = false;
  isBookingError: boolean = false;

  selectedTraveler: number | null = null;

  toggleTravelerDetails(index: number) {
    this.selectedTraveler = index;
  }

  toggleTraveler(traveler: any) {
    // Implement your logic to toggle traveler details visibility
    traveler.showPrice = !traveler.showPrice;
  }

  ngOnInit(): void {

    //set static contact information
    this.contactAddress1 = "4Floor,SunriseAvenue,Navrangpura";
    this.contactAddress2 = "";
    this.contactCountryName = "IN";
    this.contactStateName = "Gujarat";
    this.contactCityName = "Ahmedabad"
    this.contactZipCode = "380009";
    this.contactEmail = "info@amarinfotech.com";
    this.contactNumberIsd = "91";
    this.contactNumber = "9985645631";
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    console.log('Travellers Data:', this.travellersData);

    const headers = { "Content-Type": "application/json" };
    const bodyParam = {
      "agencyId": "0",
      "type": "flight-offers-pricing",
      "currencyCode": this.displayCurrency,
      "languageCode": this.languageCode,
      "flightOffers": [
        this.selectedFlight.originalResponse
      ]
    };
    this._apiService.getFlightDetail(bodyParam, headers).subscribe(data => {
      console.log(data);
      this.flightOfferDetail = data.data.data;
      let pricingArray = data.data.data.flightOffers[0].travelerPricings;

     
      
      pricingArray.forEach((ele: any, index: number) => {
        pricingArray[index].collapsed = false;
        pricingArray[index].showPrice = false;
        let travelerType = ele.travelerType;
        if (travelerType == 'HELD_INFANT') {
          travelerType = 'INFANT';
        }
        pricingArray[index].travelerType = travelerType.toLowerCase()
        //get tax total
        let taxSum = 0;
        ele.price.taxes.forEach((tax: any, taxIndex: number) => {
          taxSum += parseInt(tax.amount)
        });

        pricingArray[index].price.totalTax = taxSum;

      });
      console.log('pricingArray', pricingArray);
      this.flightOfferPriceDetail = data.data.data.flightOffers[0].processedPrice;
      this.flightPriceByTraveller = pricingArray;
      
      
    });

    
  }

  
  createPayment(flightOfferPriceDetail:any) {
    // const bodyParam = "entityId=8ac7a4c78b70a957018b7b2596770a3e" +
    const bodyParam = "entityId=8ac7a4c78b70a957018b7b2596770a3e" +
      "&registrations[0].id=8ac7a4c78b70a957018b7b1aca8e0a1c" + 
      "&registrations[1].id=8ac7a4c78b70a957018b7b2659840a45" +
    "&amount="+flightOfferPriceDetail.grandTotal+
      "&currency=SAR" +
      "&customer.givenName=darshan"+
                "&customer.middleName=amar"+
                "&customer.surname=amar"+
                "&customer.email=darshan@amarinfotech.com"+
                "&customer.phone=+966 11 5111879"+
      "&paymentType=PA";//DB
    console.log('bodyParam', bodyParam);
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer OGFjN2E0Yzc4YjcwYTk1NzAxOGI3YjE5ODU2ZDBhMTZ8Y3pDQkhtc2o5TU00Zlo5Sg=='
      })
    };
    this._apiService.createPayment(bodyParam, headers).subscribe(data => {
      console.log(data);
      let script = this._renderer2.createElement('script');
        // script.type = "text/javascript";
        script.src = "https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId="+data.id;

      this._renderer2.appendChild(this._document.body, script);

      let customScript = this._renderer2.createElement('script');
      let locale = this.languageCode;
      customScript.type = "text/javascript";
      customScript.text = `/* create custom UI */
            function wrapElement(element) {
              var id = $(element).attr("id");
              var wrapId = "wrap_" + id;
              $(element).wrap('<div id="' +wrapId+'"></div>"'); 
              return $('#'+wrapId);
            } 
            var methodMapping = {
              "card": " Click to pay with card",
              "directDebit": " Click to pay with direct debit",
              "prepayment-BOLETO": " Click to pay with Boleto",
              "prepayment-BARPAY": " Click to pay with Barpay",
              "onlineTransfer-IDEAL": " Click to pay with iDeal",
              "onlineTransfer-GIROPAY": " Click to pay with GiroPay",
              "invoice-INVOICE": " Click to pay with Invoice",
              "onlineTransfer-SOFORTUEBERWEISUNG": " Click to pay with SOFORT Uberweisung",
              "virtualAccount-PASTEANDPAY_V": " Click to pay with PASTEandPAY",
              "virtualAccount-VSTATION_V": " Click to pay with voucherstation",
              "virtualAccount-PAYPAL": " Click to pay with PayPal",
              "virtualAccount-SADAD_VA": " Click to pay with Sadad",
              "virtualAccount-TABBY": " Click to pay with TABBY",
              "virtualAccount-STC_PAY": " Click to pay with STC Pay",
              "virtualAccount-UKASH": " Click to pay with Ukash",
              "virtualAccount-QOOQO": " Click to pay with QOOQO",
              "virtualAccount-KLARNA_INVOICE": " Click to pay with Klarna Invoice",
              "virtualAccount-KLARNA_INSTALLMENTS": " Click to pay with Klarna Installments",
              "cashOnDelivery": " Click to pay cash on delivery"
            }
            var wpwlOptions = {
                locale: `+locale+`,
                style: "plain",
                paymentTarget: "_top",
              onReady: function() {
                if (wpwlOptions.locale == "ar") {
                  $(".wpwl-group").css('direction', 'ltr');
                  $(".wpwl-control-cardNumber").css({'direction': 'ltr' , "text-align":"right"});
                  $(".wpwl-brand-card").css('right', '200px');
                }
                $('.wpwl-container').each(function() {
                  var id = $(this).attr("id");
                  wrapElement(this).hide().before("<h4 class='payHead'>" + methodMapping[id.substring(0, id.lastIndexOf("_"))] + "</h4>");
                });
                $("h4").click(function() {
                  $(this).next().slideToggle();
                });
              }
            }`;
      this._renderer2.appendChild(this._document.body, customScript);

    });
  }

  createBooking() {
    console.log(this.travellersData);
    let travelers:any = [];
    this.travellersData.forEach((pasenger: any, index: number) => {
      
      let tempTravelerObj = {
        "dateOfBirth": this.datePipe.transform(pasenger.dob,"yyyy-MM-dd"),
        "name": {
          "firstName": pasenger.firstName,
          "lastName": pasenger.lastName,
          "middleName": pasenger.middleName
        },
        "gender": (pasenger.title == 'Mr') ? "MALE": "FEMALE",
        "contact": {
          "emailAddress": this.contactEmail,
          "phones": [
            {
              "deviceType": "MOBILE",
              "countryCallingCode": this.contactNumberIsd,
              "number": this.contactNumber
            }
          ],
          "documents": [
            {
              "documentType": "VISA", //pasenger.documentType, //
              "birthPlace": pasenger.birthPlace,
              "issuanceLocation": pasenger.issuanceLocation,
              "issuanceDate": this.datePipe.transform(pasenger.issuanceDate,"yyyy-MM-dd"),//pasenger.issuanceDate,
              "number": pasenger.number,
              "expiryDate": this.datePipe.transform(pasenger.expireDate,"yyyy-MM-dd"),//pasenger.expireDate,
              "issuanceCountry": pasenger.issuanceCountry,
              // "validityCountry": "",
              "nationality": pasenger.nationality,
              // "holder": "true"
            }
          ]
        }
      }

      travelers.push(tempTravelerObj);
    });
    

    const headers = { "Content-Type": "application/json" };
    const bookingRequest = {
      "agencyId": "0",
      "customer_id": (this.global.loginUserId != null) ? this.global.loginUserId : 0,
      "languageCode": localStorage.getItem('languageCode'),
      "currencyCode": localStorage.getItem('displayCurrency'),
      "supplier": "AMADEUS",
      "data": {
        "type": "flight-order",
        "flightOffers": this.flightOfferDetail.originalFlightOffers,
        "travelers": travelers,
        /*"remarks": {
          "general": [
            {
              "subType": "GENERAL_MISCELLANEOUS",
              "text": "PASSENGER NEED ASSISTANCE"
            }
          ]
        },*/
        "ticketingAgreement": {
          "option": "CONFIRM",
          "delay": "1D"
        },
        "contacts": [
          {
            "addresseeName": {
              "firstName": this.travellersData[0].firstName,
              "lastName": this.travellersData[0].lastName
            },
            "companyName": "AMADEUS",
            "purpose": "STANDARD",
            "phones": [
              {
                "deviceType": "MOBILE",
                "countryCallingCode": this.contactNumberIsd,
                "number": this.contactNumber
              }
            ],
            "emailAddress": this.contactEmail,
            "address": {
              "lines": [
                this.contactAddress1+this.contactAddress2
              ],
              "postalCode": this.contactZipCode,
              "cityName": this.contactCityName,
              "countryCode": this.contactCountryName
            }
          }
        ]
      }
    };

    this.bookingRequest = bookingRequest;
    this.isPaymentStart = true;
    console.log(bookingRequest);
    this.bookingProcessStart = true;
    localStorage.setItem('bookingRequest', JSON.stringify(bookingRequest));
    this.createPayment(this.flightOfferPriceDetail);
   /* this._apiService.bookFlight(bookingRequest, headers).subscribe(
      (data) => {
        console.log(data);
        this.bookingResponse = data.data;
        if (data.success == true) {
          this.isPaymentCompleted = true;
        } else {
          this.isBookingError = true;
        }
      }
    );*/

    //need to set this kewword at last after booking
    
  }

}
